import { useState } from "react";
import PrimaryButton from "../../../../../../components/common/PrimaryButton/PrimaryButton";
import DatatableComponent from "../../../../../../components/common/DatatableComponent/DatatableComponent";
import { Col, Input, Row } from "reactstrap";
import AddAccountsModal from "./AddAccountsModal/AddAccountsModal";
import EditAccountModal from "./EditAccountModal/EditAccountModal";

const BankAccounts = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [issEditModalOpen, setIsEditModalOpen] = useState(false);

  const accounts = [
    { bankName: "Meezan bank", accountNo: "**********1234" },
    { bankName: "HBL bank", accountNo: "**********1234" },
    { bankName: "UBL bank", accountNo: "**********1234" },
  ];

  const accountsColumns = [
    { name: "Bank Name", selector: (row) => row.bankName, minWidth: "140px" },
    { name: "Account number", selector: (row) => row.accountNo, minWidth: "160px" },
    {
      name: "Action",
      cell: () => (
        <div className="d-flex gap-2 align-items-center">
          <div
            className="cursor-pointer border border-secondary rounded py-1 px-2"
            onClick={() => setIsEditModalOpen(true)}
          >
            Edit
          </div>
          <div className="cursor-pointer">Delete</div>
        </div>
      ),
      minWidth: "140px"
    },
    { name: "Set Default", cell: () => <Input type="checkbox" />, minWidth: "120px" },
  ];

  return (
    <section>
      <Row className="g-0 gap-1 fw-semibold fs-5 d-flex align-items-center justify-content-between mb-2">
        <Col md={"auto"}>Bank Accounts</Col>
        <Col md={"auto"} className="text-end">
          <PrimaryButton
            name="Add New Account"
            onClick={() => setIsModalOpen(true)}
          />
        </Col>
      </Row>

      <Row className="g-0">
        <Col xl={9}>
          <div className="p-2 bg-white">
            <div className="border border-subtle-secondary p-3">
              <DatatableComponent
                data={accounts}
                columns={accountsColumns}
                type="gray"
              />
            </div>
          </div>
        </Col>
      </Row>

      <AddAccountsModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />

      <EditAccountModal
        isModalOpen={issEditModalOpen}
        setIsModalOpen={setIsEditModalOpen}
      />
    </section>
  );
};

export default BankAccounts;